import React, { useEffect, useState, useRef } from "react";
import UserService from "../../utils/keycloak.service.js";
import LoadingIcon from "../custom/inputs/ERPSLoadingIcon.js";
import { useDispatch } from "react-redux";
import appConfigType from "../../actions/types/app.config.type";
import ErrorMessage from "../custom/containers/ErrorMessage";
import { ResponsiveBox, Typography } from "../primitives";
import { t } from "i18next";

const LOGIN_ATTEMPT_KEY = "erpsLoginAttempts";
const MAX_LOGIN_ATTEMPTS = 2;

export default function KcLanding(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const dispatch = useDispatch();

  const [errorMessage, setErrorMessage] = useState(null);
  const errorRef = useRef();

  useEffect(() => {
    const logoutClicked = localStorage.getItem("logoutClicked");
    const fiNumber = localStorage.getItem("fiNumber");
    const fiName = localStorage.getItem("fiName");
    const roleType = localStorage.getItem("type");
    const referrer = sessionStorage.getItem("referrer") || '';

    async function initKc() {
      await UserService.initKeycloak({ props, setIsLoggedIn, setErrorMessage });

      if (logoutClicked) {
        if (roleType === "webportal" || (roleType === "billpay" && referrer == '')) {
          localStorage.clear();
          sessionStorage.clear();
          localStorage.setItem("fiName", fiName);
          localStorage.setItem("fiNumber", fiNumber);
          localStorage.setItem("type", roleType);
          dispatch({
            type: appConfigType.LOAD_ENV_PROPERTY_SUCCESS,
            data: null,
          });
          window.location.href = "/";
        } else if(roleType === "billpay") {
          sessionStorage.clear();
        } else {
          sessionStorage.clear();
          localStorage.clear();
          UserService.doLogin();
        }
      } else if (!UserService.isLoggedIn()) {
        const attempts = Number(sessionStorage.getItem(LOGIN_ATTEMPT_KEY) || 0);
        if (attempts >= MAX_LOGIN_ATTEMPTS) {
          sessionStorage.removeItem(LOGIN_ATTEMPT_KEY);
          setErrorMessage(t("erps.error.message.sessionexpired"));
        } else {
          sessionStorage.setItem(LOGIN_ATTEMPT_KEY, String(attempts + 1));
          UserService.doLogin();
        }
      } else {
        sessionStorage.removeItem(LOGIN_ATTEMPT_KEY);
      }
    }
    initKc();
    // if (!logoutClicked) {
    //   localStorage.setItem("logoutClicked", "true");
    // }
  }, []);

  const logout = () => {
    // localStorage.setItem("logoutClicked", "true");
    // debugger
    UserService.doLogout();
  };
  return (
    <>
      {errorMessage ? (
        <ResponsiveBox className="manageUsers__errorMsg__container" role="alert" mt={2}>
            <ErrorMessage error={errorMessage} errorRef={errorRef} />
        </ResponsiveBox>
      ) : (
        <ResponsiveBox textAlign={"center"} mt={30}>
          <LoadingIcon />
        </ResponsiveBox>
      )}

      {/* {isLoggedIn ? (
        <>
          {" "}
          <Typography variant="h3">Successfully logged in</Typography>{" "}
          <ERPSBaseLink
            to="/"
            className="header__link__active"
            onClick={logout}
            label={"Logout"}
          />
        </>
      ) : (
        <LoadingIcon />
      )} */}
    </>
  );
}
